<template>
<div>
    <span>{{ checked ? '◉' : '○' }}</span>
    <button :class="`checkbox ${checked ? '' : 'inactive'}`">
        <slot>
        </slot>   
    </button>    
</div>
</template>

<script>
export default {
    name: "check-button",
    props: ["checked"]
}
</script>

<style lang="scss" scoped>
    span {
        margin-right: 0.5em;
    }
</style>
